export const actionTypes = {
    PHONE_NUMBER_CALL: "PHONE_NUMBER_CALL",
    SIP_ENDPOINT_CALL: "SIP_ENDPOINT_CALL",
    SIP_ENDPOINT_CALL_SCREEN_SHARE: "SIP_ENDPOINT_CALL_SCREEN_SHARE",
    CALL_THE_QUEUE: "CALL_THE_QUEUE"

};
